// Custom  error middleware for application to catch all errors occurs in reducer.

import { setShowErrorScreen } from './global-store/global-store.reducer';
import { reportError } from '../telemetry';

// next[method] called to send action to reducer.
export const customErrorMiddleware = (store: any) => (next:any) => (action: any) => {
  const { dispatch } = store;
  try {
    return next(action);
  } catch (error) {
    dispatch(setShowErrorScreen(true));
    console.error('reducer error', error);
    reportError(
      error instanceof Error ? error : new Error(String(error)),
      {
        source: 'ReduxMiddleware',
        action: action?.type || 'unknown',
      },
    );
    throw error;
  }
};

export default customErrorMiddleware;
